import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ToolbarButton} from '../../../models/toolbar-button/toolbar-button';
import {ServiceDefinitionVersionComponent} from './service-definition-version.component';

const routes: Routes = [
  {
    path: '',
    component: ServiceDefinitionVersionComponent,
    data: {
      activeLink: ToolbarButton.CATALOGUE,
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceDefinitionVersionRoutingModule {
}
